module.exports = __webpack_public_path__ + "static/nexus-Circle.d3445904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nexus-Circle.jpg
// module id = 357
// module chunks = 35783957827783